import { z } from "zod";

export const AddressSourceSchema = z.object({
  id: z.string().min(8).max(80),
  provider: z.literal("photon-osm"),
  sourceUrl: z
    .string()
    .regex(/^https:\/\/www\.openstreetmap\.org\/(node|way|relation)\/\d+$/),
  accuracy: z.enum(["house", "street"]),
  resolvedAt: z.number().finite(),
});
export const ResolvedAddressSchema = z.object({
  address: z.string().min(3).max(160),
  district: z.string().min(2).max(100),
  location: z.tuple([
    z.number().min(47.2).max(55.2),
    z.number().min(5.8).max(15.2),
  ]),
  street: z.string().min(2).max(140),
  houseNumber: z.string().max(30).optional(),
  postcode: z.string().max(12).optional(),
  addressSource: AddressSourceSchema,
});
export type ResolvedAddress = z.infer<typeof ResolvedAddressSchema>;
